import { React, PT, fetchApi } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import { Modal, Button, Dimmer, Loader } from 'semantic-ui-react';

export class StatusModal extends React.Component {
  state = {}

  loadAndGo = () => {
    const { accountId } = this.props;
    this.setState({ opened: true, loading: true }, async () => {
      const { body } = await fetchApi({
        url: '/payments/status',
        body: { account_id: accountId },
      });
      this.setState({ loading: false, body });
    });
  }

  render() {
    const { opened, loading, body } = this.state;
    return (
      <Modal
        open={opened}
        trigger={<Button floated="right" size="mini" onClick={this.loadAndGo}>Wallet Status</Button>}
      >
        <Modal.Header>Wallet Status</Modal.Header>
        <Modal.Content>
          <Dimmer.Dimmable dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <JSONTree data={body} shouldExpandNode={(k, d, l) => l <= 1} />
            </div>
          </Dimmer.Dimmable>
        </Modal.Content>
        <Modal.Actions>
          <Button basic onClick={() => this.setState({ opened: false, body: null })}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

StatusModal.propTypes = {
  accountId: PT.number,
};

StatusModal.defaultProps = {
  accountId: 0,
};
